module.exports = __webpack_public_path__ + "img/br50.91979d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br50.jpg
// module id = bkbF
// module chunks = 0